import React from "react";

const MLBPlayerRequestContext = React.createContext({});

export default MLBPlayerRequestContext;
